import { SidebarSection } from "./sidebar";
import { NavbarSection } from "./navbar";
import { Outlet } from "react-router-dom";
import { Container } from "react-bootstrap";
import { useState } from "react";

export const DashboardLayout = () => {
  const [showSidebar, setShowSidebar] = useState(false);
  return (
    <section className="main-layout bg-light ">
      <SidebarSection
        setShowSidebar={setShowSidebar}
        showSidebar={showSidebar}
      />
      <main
        className={`w-100 pb-4 main-section ${
          showSidebar ? "open-sidebar" : ""
        }`}
      >
        <header className="mb-4">
          <NavbarSection showLogo={!showSidebar} />
        </header>
        <Container>
          <Outlet />
        </Container>
      </main>
    </section>
  );
};
